import { render, staticRenderFns } from "./OnboardCustomer.vue?vue&type=template&id=33876673&scoped=true"
import script from "./OnboardCustomer.vue?vue&type=script&lang=js"
export * from "./OnboardCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33876673",
  null
  
)

export default component.exports